import React from 'react';

import Input from './Input';
import InputWithCountryField from './InputWithCountryField';

import { fontSize, colors } from 'styles/cp';

export interface Props {
  label: string | React.ReactNode;
  className?: string;
  [propName: string]: any;
  countryField?: Record<string, any>;
  updateCountry?: Function;
}

const LabeledInput: React.FC<Props> = (props: any) => {
  const { className, label, countryField, updateCountry, ...rest } = props;
  const shouldShowCountryFieldInput = countryField && updateCountry;
  return (
    <div className={className}>
      <style jsx>{`
        label {
          font-family: AvenirNextforINTUIT-Demi;
          line-height: 20px;
          font-size: ${fontSize.xxs};
          color: ${colors.darkGray};
          display: block;
        }
      `}</style>
      <label>
        {label}
        {shouldShowCountryFieldInput ? (
          <InputWithCountryField country={countryField} updateCountry={updateCountry} {...rest} />
        ) : (
          <Input {...rest} />
        )}
      </label>
    </div>
  );
};

export default LabeledInput;
